import { render, staticRenderFns } from "./SingleSocialNetworkLink.vue?vue&type=template&id=4ca9e8ce&scoped=true&"
import script from "./SingleSocialNetworkLink.vue?vue&type=script&lang=js&"
export * from "./SingleSocialNetworkLink.vue?vue&type=script&lang=js&"
import style0 from "./SingleSocialNetworkLink.vue?vue&type=style&index=0&id=4ca9e8ce&scoped=true&lang=scss&"
import style1 from "./SingleSocialNetworkLink.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca9e8ce",
  null
  
)

export default component.exports